import fieldMixin from '@phoenix/mixins/fieldMixin';

export default {
  mixins: [fieldMixin],
};
